<template>
  <div class="stafftitle bgps">{{ name }}</div>
</template>

<script>
export default {
  props: ["name"],
};
</script>

<style lang="scss" scoped>
.stafftitle {
  width: 17.19vw;
  height: 1.04vw;
  background: url("../../assets/image/二级标题-背景.png") no-repeat;
  color: white;
  text-indent: 1.56vw;
}
</style>
